var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.IsDashboardUser)?_c('GuestDashboard'):(_vm.IsCRMUser)?_c('EntryIndex'):_c('div',[_vm._v(" Không xác định quyền truy cập. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }